import React from "react";
import "./MyGroupApp.css";
import {MyGroupApps} from "../logic/APITypes";
import {NameLogo} from "./NameLogo";
import {Link} from "react-router-dom";
import {HomeApp} from "./HomeApp";

const MyGroupApp = ({id, name, apps}: MyGroupApps) => {
  return (
    <div className="myGroupApp">
      <Link
        className="myGroupApp__row myGroupApp__title"
        to={"/groups/" + id}
        state={{from: "home"}}
      >
        <NameLogo text={name} id={id} size={48} />
        {name}
      </Link>
      <div className="myGroupApp__row">
        {apps.map((app) => (
          <HomeApp
            key={app.id}
            {...app}
            detailsLink={`/groups/${id}/apps/installed/${app.id}`}
          />
        ))}
      </div>
    </div>
  );
};

export {MyGroupApp};
